import { getPartnerDataRequest } from '@/modules/request'

export async function getPartners () {
  let partners = {
    title: 'succ_nav_partner',
  }
  let partnerData = []
  const data = await getPartnerDataRequest(1)
  const sections = [...partnerData, ...data]
  return {
    ...partners,
    sections
  }
}

const navItem = {
  about: {
    text: 'succ_nav_about',
    href: '#about'
  },
  prizes: {
    text: 'succ_nav_prizes',
    href: '#prizes'
  },
  theme: {
    text: 'succ_nav_theme',
    href: '#theme'
  },
  tutors: {
    text: 'succ_nav_tutor',
    href: '#tutors'
  },
  timeline: {
    text: 'succ_nav_timeline',
    href: '#timeline'
  },
  partner: {
    text: 'succ_nav_partner',
    href: '#partners'
  },
  faq: {
    text: 'succ_nav_faq',
    href: '#FAQ'
  },
  contact: {
    text: 'succ_nav_contact',
    href: '#contact'
  },
  careers: {
    text: 'succ_nav_careers',
    href: 'https://careers.shopee.tw/',
    target: '_blank'
  }
}

const sighUpLink = "https://techatshopee.formstack.com/forms/succtw2021"

function message () {
  return {
    application: {
      title: 'Shopee Ultimate Case Challenge 2021 | Business Case Competition By Shopee Taiwan',
      desc: 'Shopee Ultimate Case Challenge 為蝦皮購物首次在台灣舉辦之商業個案競賽，此競賽目的為藉由商業經營實際案例，提供全台各大專院校學生理論與實務結合的機會，期望能從中找到最具創新力及創造力的學生。藉由此競賽獨特的導師機制，您的團隊可以實際參與專案題目，並且與蝦皮內部高階主管進行交流，創造可以實際在蝦皮台灣及其他海外據點實際執行的解決方案。如果您已經準備好接受挑戰，立即組隊報名 Shopee Ultimate Case Challenge！',
      startDate: '2021-2-22T00:00+08:00',
      endDate: '2021-05-31T23:59+08:00'
    },
    navbar: [
      navItem.about,
      navItem.prizes,
      navItem.theme,
      navItem.timeline,
      navItem.tutors,
      navItem.faq,
      navItem.partner,
      navItem.contact,
      navItem.careers
    ],
    banner: {
      text: 'succ_banner_text',
      registerBtn: 'succ_banner_sign_up',
      sighUpLink,
      explain: 'succ_banner_explain',
    },
    sighUpBtn: {
      sighUpLink,
      btnText: 'succ_banner_sign_up'
    },
    countDown: 'succ_countdown',
    about: {
      title: 'succ_nav_about',
      desc: 'succ_about_content'
    },
    aim: {
      title: 'succ_title_aim',
      list: [{
        desc: 'succ_aim_text1',
        icon: require('@succ/public/images/aim/bg-1.svg')
      }, {
        desc: 'succ_aim_text2',
        icon: require('@succ/public/images/aim/bg-2.svg')
      }, {
        desc: 'succ_aim_text3',
        icon: require('@succ/public/images/aim/bg-3.svg')
      }],
      cardList: [{
        title: 'succ_aim_list_title_1',
        desc: 'succ_aim_list_desc_1',
        icon: require('@succ/public/images/aim/bg-4.svg')
      }, {
        title: 'succ_aim_list_title_2',
        desc: 'succ_aim_list_desc_2',
        icon: require('@succ/public/images/aim/bg-5.svg')
      }, {
        title: 'succ_aim_list_title_3',
        desc: 'succ_aim_list_desc_3',
        icon: require('@succ/public/images/aim/bg-6.svg')
      }, {
        title: 'succ_aim_list_title_4',
        desc: 'succ_aim_list_desc_4',
        icon: require('@succ/public/images/aim/bg-7.svg')
      }]
    },
    theme: {
      title: navItem.theme.text,
      title1: 'succ_theme_title',
      sections: [{
        title: 'succ_theme_section_title_1',
        desc: 'succ_theme_section_desc_1'
      }, {
        title: 'succ_theme_section_title_2',
        list: [{
          text: 'succ_theme_section_pr_1'
        }, {
          text: 'succ_theme_section_pr_2',
          list: [{
            text: 'succ_theme_section_pr_2_1'
          }, {
            text: 'succ_theme_section_pr_2_2'
          }, {
            text: 'succ_theme_section_pr_2_3'
          }, {
            text: 'succ_theme_section_pr_2_4',
            list: [{
              text: 'succ_theme_section_pr_2_4_1'
            }, {
              text: 'succ_theme_section_pr_2_4_2'
            }, {
              text: 'succ_theme_section_pr_2_4_3'
            }]
          }]
        }, {
          text: 'succ_theme_section_pr_3',
          list: [{
            text: 'succ_theme_section_pr_3_1'
          },{
            text: 'succ_theme_section_pr_3_2'
          }, {
            text: 'succ_theme_section_pr_3_3'
          }, {
            text: 'succ_theme_section_pr_3_4'
          }]
        }]
      }, {
        title: 'succ_theme_section_title_3',
        desc: 'succ_theme_section_desc_3',
        list: [{
          text: 'succ_theme_section_es_1'
        }, {
          text: 'succ_theme_section_es_2'
        }, {
          text: 'succ_theme_section_es_3'
        }, {
          text: 'succ_theme_section_es_4'
        }, {
          text: 'succ_theme_section_es_5'
        }]
      }]
    },
    timeline: {
      title: 'succ_nav_timeline',
      list: [{
        date: 'succ_timeline_date_1',
        title: 'succ_timeline_title_1',
        desc: ['succ_timeline_desc_1']
      }, {
        date: 'succ_timeline_date_2',
        title: 'succ_timeline_title_2',
        desc: ['succ_timeline_desc_2']
      }, {
        date: 'succ_timeline_date_3',
        title: 'succ_timeline_title_3',
        desc: 'succ_timeline_desc_3'
      }, {
        date: 'succ_timeline_date_4',
        title: 'succ_timeline_title_4',
        desc: ['succ_timeline_desc_4']
      }, {
        date: 'succ_timeline_date_5',
        title: 'succ_timeline_title_5',
        desc: ['succ_timeline_desc_5']
      }, {
        date: 'succ_timeline_date_6',
        title: 'succ_timeline_title_6',
        desc: ['succ_timeline_desc_6']
      }],
      explain: 'succ_timeline_explain'
    },
    tutors: {
      title: 'succ_nav_tutor',
      list: [{
        image: require('@succ/public/images/tutors/tutor-1.svg'),
        desc: 'succ_tutor_desc_1',
        word: 'succ_tutor_desc_1_1'
      }, {
        image: require('@succ/public/images/tutors/tutor-2.svg'),
        desc: 'succ_tutor_desc_2',
        word: 'succ_tutor_desc_2_1'
      }, {
        image: require('@succ/public/images/tutors/tutor-3.svg'),
        desc: 'succ_tutor_desc_3',
        word: 'succ_tutor_desc_3_1'
      }, {
        image: require('@succ/public/images/tutors/tutor-4.svg'),
        desc: 'succ_tutor_desc_4',
        word: 'succ_tutor_desc_4_1'
      }, {
        image: require('@succ/public/images/tutors/tutor-5.svg'),
        desc: 'succ_tutor_desc_5',
        word: 'succ_tutor_desc_5_1'
      }]
    },
    prizes: {
      title: 'succ_nav_prizes',
      list: [{
        title: 'succ_prize_title_1',
        money: 'succ_prize_money_1',
        chances: 'succ_prize_chance_1'
      }, {
        title: 'succ_prize_title_2',
        money: 'succ_prize_money_2',
        chances: 'succ_prize_chance_2'
      }, {
        title: 'succ_prize_title_3',
        money: 'succ_prize_money_3',
        chances: 'succ_prize_chance_3'
      }],
      explain: 'succ_prize_explain'
    },
    faqs: {
      title: 'succ_title_faqs',
      sections: [{
        title: 'succ_faq_title_about',
        list: [{
          question: 'succ_faq_about_q1',
          desc: ['succ_faq_about_a1']
        }, {
          question: 'succ_faq_about_q2',
          desc: ['succ_faq_about_a2']
        }, {
          question: 'succ_faq_about_q3',
          desc: ['succ_faq_about_a3']
        }, {
          question: 'succ_faq_about_q4',
          desc: ['succ_faq_about_a4']
        }, {
          question: 'succ_faq_about_q5',
          desc: ['succ_faq_about_a5']
        }]
      }, {
        title: 'succ_faq_title_qualified',
        list: [{
          question: 'succ_faq_qualified_q1',
          desc: ['succ_faq_qualified_a1']
        }, {
          question: 'succ_faq_qualified_q2',
          desc: ['succ_faq_qualified_a2']
        }, {
          question: 'succ_faq_qualified_q3',
          desc: ['succ_faq_qualified_a3']
        }, {
          question: 'succ_faq_qualified_q4',
          desc: ['succ_faq_qualified_a4']
        }, {
          question: 'succ_faq_qualified_q5',
          desc: ['succ_faq_qualified_a5']
        }, {
          question: 'succ_faq_qualified_q6',
          desc: ['succ_faq_qualified_a6']
        }, {
          question: 'succ_faq_qualified_q7',
          desc: ['succ_faq_qualified_a7']
        }]
      }, {
        title: 'succ_faq_title_sign_up',
        list: [{
          question: 'succ_faq_sign_up_q1',
          desc: ['succ_faq_sign_up_a1']
        }, {
          question: 'succ_faq_sign_up_q2',
          desc: ['succ_faq_sign_up_a2']
        }, {
          question: 'succ_faq_sign_up_q3',
          desc: ['succ_faq_sign_up_a3']
        }, {
          question: 'succ_faq_sign_up_q4',
          desc: ['succ_faq_sign_up_a4']
        }, {
          question: 'succ_faq_sign_up_q5',
          desc: ['succ_faq_sign_up_a5']
        }]
      }, {
        title: 'succ_faq_title_tutor',
        list: [{
          question: 'succ_faq_tutor_q1',
          desc: ['succ_faq_tutor_a1']
        }, {
          question: 'succ_faq_tutor_q2',
          desc: ['succ_faq_tutor_a2']
        }, {
          question: 'succ_faq_tutor_q3',
          desc: ['succ_faq_tutor_a3']
        }]
      }]
    },
    partners: {
      title: 'succ_nav_partner',
      sections: [{
        title: 'succ_host_title',
        justifyCenter: true,
        logos: [{
          name: 'succ_partner_shopee',
          image: require('@succ/public/images/partners/shopee.jpg'),
          link: 'https://careers.shopee.tw',
          isShopee: true
        }]
      }, {
        title: 'succ_government_title',
        justifyCenter: true,
        logos: [{
          name: 'succ_partner_goSmart',
          image: require('@succ/public/images/partners/go-smart.jpg'),
          link: 'https://www.citiesgosmart.org/'
        }]
      }, {
        title: 'succ_nav_partner',
        logos: [{
          name: 'succ_partner_ntuscmarketingclub',
          image: require('@succ/public/images/partners/s&c.jpg'),
          link: 'https://www.facebook.com/ntuscmarketingclub/',
        }, {
          name: 'succ_partner_NTUDAC',
          image: require('@succ/public/images/partners/dac.jpg'),
          link: 'https://www.facebook.com/NTUDAC/',
        }, {
          name: 'succ_partner_NCCUCG',
          image: require('@succ/public/images/partners/NCCUCG.jpg'),
          link: 'https://www.facebook.com/NCCUCG/',
        }, {
          name: 'succ_partner_Blockchain',
          image: require('@succ/public/images/partners/Blockchain.jpg'),
          link: 'https://www.facebook.com/Blockchain.at.NCCU/',
        }, {
          name: 'succ_partner_cicii',
          image: require('@succ/public/images/partners/cicii.jpg'),
          link: 'https://cicii.nccu.edu.tw/',
        }, {
          name: 'succ_partner_nccubig',
          image: require('@succ/public/images/partners/nccubig.jpg'),
          link: 'https://cicii.nccu.edu.tw/nccubig/',
        }, {
          name: 'succ_partner_tmba',
          image: require('@succ/public/images/partners/TMBA.png'),
          link: 'https://www.facebook.com/TMBA.tw/',
        }, {
          name: 'succ_partner_oie',
          image: require('@succ/public/images/partners/OIE.jpg'),
          link: 'https://www.facebook.com/OIENCCUC/',
        }, {
          name: 'succ_partner_nccu',
          image: require('@succ/public/images/partners/nccu.jpg'),
          link: 'https://www.cs.nccu.edu.tw/web/index/index.jsp',
        }, {
          name: 'succ_partner_NTUAIClub',
          image: require('@succ/public/images/partners/NTUAIClub.jpg'),
          link: 'https://www.facebook.com/NTUAIClub/',
        }, {
          name: 'succ_partner_NTUIMSA',
          image: require('@succ/public/images/partners/NTUIMSA.jpg'),
          link: 'https://www.facebook.com/NTUIMSA',
        },  {
          name: 'succ_partner_alphacamp',
          image: require('@succ/public/images/partners/alphacamp.jpg'),
          link: 'https://tw.alphacamp.co/',
        }, {
          name: 'succ_partner_ntuconsulting',
          image: require('@succ/public/images/partners/ntuconsulting.jpg'),
          link: 'https://www.facebook.com/ntuconsulting',
        }, {
          name: 'succ_partner_NTU',
          image: require('@succ/public/images/partners/NTU.jpg'),
          link: 'https://www.facebook.com/NTU.CSIE.Council',
        }, {
          name: 'succ_partner_yongxi',
          image: require('@succ/public/images/partners/yongxi.jpg'),
          link: 'https://www.yongxi-stat.com/',
        }, {
          name: 'succ_partner_skyline',
          image: require('@succ/public/images/partners/skyline.jpg'),
          link: 'https://skyline.tw/',
        }, {
          name: 'succ_partner_idea',
          image: require('@succ/public/images/partners/idea.jpg'),
          link: 'https://news.idea-show.com/',
        }, {
          name: 'succ_partner_jinrih',
          image: require('@succ/public/images/partners/jinrih.jpg'),
          link: 'https://www.jinrih.com/',
        }, {
          name: 'succ_partner_tcincubator',
          image: require('@succ/public/images/partners/tcincubator.jpg'),
          link: 'https://www.tcincubator.com/',
        }, {
          name: 'succ_partner_cupoy',
          image: require('@succ/public/images/partners/cupoy.jpg'),
          link: 'https://www.cupoy.com/home',
        }, {
          name: 'succ_partner_sharecourse',
          image: require('@succ/public/images/partners/sharecourse.jpg'),
          link: 'https://www.sharecourse.net/sharecourse/',
        }, {
          name: 'succ_partner_migo',
          image: require('@succ/public/images/partners/migo.jpg'),
          link: 'https://www.migocorp.com/',
        }, {
          name: 'succ_partner_code_taipei',
          image: require('@succ/public/images/partners/codeTaipei.jpg'),
          link: 'https://www.merica.com.tw/',
        },  {
          name: 'succ_partner_wemake',
          image: require('@succ/public/images/partners/wemake.png'),
          link: 'https://www.facebook.com/We-Make-Decision-Academy-%E6%90%9E%E5%AE%9A%E5%AD%B8%E9%99%A2-735372489985355/',
        }, {
          name: 'succ_partner_ntueIRC',
          image: require('@succ/public/images/partners/ntueIRC.jpg'),
          link: 'https://www.facebook.com/ntueIRC/',
        }, {
          name: 'succ_partner_pccu',
          image: require('@succ/public/images/partners/pccu.jpg'),
          link: 'https://www.sce.pccu.edu.tw/',
        }, {
          name: 'succ_partner_merica',
          image: require('@succ/public/images/partners/merica.jpg'),
          link: 'https://www.merica.com.tw/',
        }]
      }]
    },
    chance: {
      title: 'succ_title_chance',
      list: [{
        question: 'succ_chance_title_1',
        answers: ['succ_chance_desc_1_1', 'succ_chance_desc_1_2']
      }, {
        question: 'succ_chance_title_2',
        answers: ['succ_chance_desc_2_1', 'succ_chance_desc_2_2', 'succ_chance_desc_2_3']
      }, {
        question: 'succ_chance_title_3',
        answers: ['succ_chance_desc_3_1', 'succ_chance_desc_3_2', 'succ_chance_desc_3_3']
      }],
      explain: 'succ_chance_explain'
    },
    contact: {
      title: 'succ_title_contact',
      desc: [
        'succ_contact_desc_1',
        'succ_contact_desc_2'
       ],
      btn: 'succ_contact_btn',
      btnLink: 'mailto:recruit.tw@shopee.com'
    },
    footer: {
      logoStatic: true,
      follow: 'succ_follow_us',
      social: [{
        href: 'https://www.facebook.com/shopeecareers.tw/',
        name: 'facebook',
        icon: require('@/assets/images/icon-facebook.svg')
      }, {
        href: 'https://www.instagram.com/shopee_tw/?hl=zh-tw',
        name: 'instagram',
        icon: require('@/assets/images/icon-instagram.svg')
      }, {
        href: 'https://linkedin.com/company/shopee',
        name: 'linkedin',
        icon: require('@/assets/images/icon-linkedin.svg')
      }],
      links: [[
        navItem.about,
        navItem.prizes,
        navItem.theme
      ], [
        navItem.timeline,
        navItem.tutors,
        navItem.faq,
      ], [
        navItem.partner,
        navItem.contact,
        navItem.careers
      ]],
      tc: 'pdf/succ-terms-and-conditions.pdf',
      privacyPolicy: 'pdf/succ-privacy-policy.pdf',
      copyright: 'Copyright © Shopee Limited. Trademarks belong to their respective owners. All rights reserved.'
    }
  }
}

export default message;
